// extracted by mini-css-extract-plugin
module.exports = {"analytic":"analytic_analytic__33Taa"};